import { AppEnvName } from "../config/app-env";

export class Endpoints {
  static backendApi: string;
  static initialize(envName: AppEnvName): void {
    switch (envName) {
      case AppEnvName.LOCAL:
        this.initializeLocal();
        break;
      case AppEnvName.SANDBOX:
        this.initializeSandbox();
        break;
      case AppEnvName.PRODUCTION:
        this.initializeProduction();
        break;
      default:
        // Default to local environment if not recognized
        console.warn(`Environment ${envName} not recognized, defaulting to LOCAL`);
        this.initializeLocal();
        break;
    }
  }
  private static urlWithEndpoint(
    endPoint: string,
    envName: AppEnvName
  ): string {
    switch (envName) {
      case AppEnvName.LOCAL:
        return `http://localhost:${endPoint}`;
      case AppEnvName.SANDBOX:
        return `https://api-staging-${endPoint}.joyfultechnology.co.uk`;
      case AppEnvName.PRODUCTION:
        return `http://ultimatecc.enorus.com`;
      default:
        // Default to localhost if environment not recognized
        console.warn(`URL environment ${envName} not recognized, defaulting to localhost`);
        return `http://localhost:${endPoint}`;
    }
  }

  private static initializeLocal(): void {
    const getUrl = (endPoint: string) =>
      this.urlWithEndpoint(endPoint, AppEnvName.LOCAL);
    this.backendApi = getUrl("5000");
  }

  private static initializeSandbox(): void {
    const getUrl = (endPoint: string) =>
      this.urlWithEndpoint(endPoint, AppEnvName.SANDBOX);
    this.backendApi = getUrl("5000");
  }

  private static initializeProduction(): void {
    const getUrl = (endPoint: string) =>
      this.urlWithEndpoint(endPoint, AppEnvName.PRODUCTION);
    this.backendApi = getUrl("5000");
  }
}
